/**
 * The six finishes Mitch picked on 2026-09-16, in the order they were drawn.
 * A finish changes what a hole is and what runs under the lanes; the pegs are
 * the same in all six. `edged` is the default, his call the same day.
 *
 * The list lives in the state band because the settings store saves a finish.
 * The board's geometry, a band above, imports it from here.
 */
export const ARCH_FINISHES = ['dots', 'ticks', 'gray', 'drilled', 'edged', 'strip'] as const;

export type ArchFinish = (typeof ARCH_FINISHES)[number];

export const DEFAULT_FINISH: ArchFinish = 'edged';

/**
 * The finishes every player may use: Rimshot (`edged`), the default. Every
 * other finish is for members (`brain/decisions.md` 2026-10-01, "Rimshot is
 * great"). The `game-paywall` sketch drew `dots` as the free one; the decision
 * overrides it.
 */
export const FREE_BOARD_FINISHES: ReadonlySet<ArchFinish> = new Set<ArchFinish>(['edged']);
